<template>
  <div class="search-results-new-d__category-path">
    <a
      :href="link"
      class="js-suggest-item search-results-new-d__category-path-title"
      @click="$emit('clickHandler', title)"
      v-html="getSearchCaption(title, query.trim().toLowerCase())"
    ></a>
    <a
      v-for="item in breadcrumbs"
      :key="item.name"
      class="search-results-new-d__category-path-item"
      :href="item.url"
      @click="$emit('clickHandler', item.name)"
      v-html="getSearchCaption(item.name, query.trim().toLowerCase())"
    ></a>
  </div>
</template>

<script>
import AutocompleteMixin from '@/js/helpers/mixins/AutocompleteMixin';

export default {
  name: 'SuggestCategoryItemD',
  mixins: [AutocompleteMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    breadcrumbs: {
      type: Array,
      default: () => ([]),
    },
    query: {
      type: String,
      default: '',
    },
  },
};
</script>
